export default __webpack_public_path__ + "static/media/NoProjectMobile.2126808d.png";